// TEMPORARY: This hook will be removed once the manage roles feature is fully released.
// To enable the feature in a browser: localStorage.setItem("manage_roles_enabled", "true")
export const useManageRolesFeatureFlag = (): boolean =>
  localStorage.getItem("manage_roles_enabled") === "true";
